// Editable placeholder schedule. Confirm actual class timings with the
// client before publishing — do not present as final until verified.
const schedule = {
  Monday: [
    { time: "6:00 AM", session: "Strength Training" },
    { time: "8:00 AM", session: "Functional Training" },
    { time: "6:00 PM", session: "Cardio Conditioning" },
  ],
  Tuesday: [
    { time: "6:00 AM", session: "Muscle Building" },
    { time: "8:00 AM", session: "Weight Management" },
    { time: "6:00 PM", session: "Personal Training" },
  ],
  Wednesday: [
    { time: "6:00 AM", session: "Strength Training" },
    { time: "8:00 AM", session: "Cardio Conditioning" },
    { time: "6:00 PM", session: "Functional Training" },
  ],
  Thursday: [
    { time: "6:00 AM", session: "Muscle Building" },
    { time: "8:00 AM", session: "Weight Management" },
    { time: "6:00 PM", session: "Strength Training" },
  ],
  Friday: [
    { time: "6:00 AM", session: "Functional Training" },
    { time: "8:00 AM", session: "Cardio Conditioning" },
    { time: "6:00 PM", session: "Personal Training" },
  ],
  Saturday: [
    { time: "7:00 AM", session: "Community Workout" },
    { time: "9:00 AM", session: "Weight Management" },
  ],
};

export default schedule;
